import { Link } from 'react-router-dom';

import '../CsvJsonInfoPages.scss';


function HGVMileageCalculation() {

  return (
    <div className='csv-json-info-pages-container'>
      <h1>Used Values - HGV Mileage Calculation</h1>
      <p>
        <b>Please note this page has been updated to reflect a change in the way calculations are done.</b><br /><br />

        If your required mileage falls between 2 mileage points, please use the same calculation method as all other vehicles. (<Link to="/CsvJson/used-values-mileage-calculation">Used Values - Mileage Calculation</Link>)<br /><br />

        The following method is only valid when the required mileage is above the highest mileage that we provide.<br /><br />

        Please note: If there are no mileages provided in the ASCII, a valuation is not possible.<br />
        For a required mileage above our maximum mileage valuation, select our highest mileage given.<br />
        An adjustment factor is then found as (Our mileage - Required mileage) * 0.0003.<br />
        The prices for the nearest existing value are multiplied by this value to give an adjustment of + 3% per 100,000 KMs.<br /><br />

        <b>Formula for Heavy Commercials</b><br />
        To calculate a valuation (V) for a custom mileage (M) where (V1, M1) are nearest (price, mileage)<br />
        Percentage = (M1 - M) * 0.0003<br />
        V = Truncate ((P * V1) + V1)<br /><br />

        <b>Example 1</b><br />
        Mileage required: 850<br />
        Last supplied Mileage: 790<br />
        Supplied price: 12700<br />
        (790 - 850) * 0.0003 = -0.018<br />
        Truncate ((-0.018 * 12700) + 12700) = 12471<br /><br />

        Round to nearest £50 = £12450<br /><br />

        <b>Example 2</b><br />
        Mileage required: 675<br />
        Nearest supplied mileage: 560<br />
        Supplied price: 5795<br />
        (560 - 675) * 0.0003 = -0.0345<br />
        Truncate ((-0.0345 * 5795) + 5795) = 5595<br /><br />

        Round to nearest £25 = £5600<br /><br />

        <b>Rounding Calculations</b><br />
        To obtain the rounded (final) price the following rules are used:<br /><br />

        <b>Trade Prices - Clean, Average, Below</b><br/>
        Up to £1000        - Nearest £10<br />
        Up to £10,000    - Nearest £25<br />
        Up to £30,000    - Nearest £50<br />
        Over £30,000      - Nearest £100<br /><br />

        <b>Retail Price</b><br />
        Up to £10,000 - Nearest £25 then<br/>
        x000 -&gt; x000 - 5<br/>
        x025 -&gt; x025 - 30<br/>
        x050 -&gt; x050 + 45<br/>
        x075 -&gt; x075 + 20<br/><br/>

        Up to £20,000 - Nearest £50 then<br/><br/>

        xx000 -&gt; xx000 - 5<br/>
        xx050 -&gt; xx050 + 45<br/>
        xxx00 -&gt; xxx00 - 5<br/><br/>

        Over £20,000 - Nearest £250

      </p>

    </div>
  );
}

export default HGVMileageCalculation;
